import styled, {keyframes} from "styled-components";

const pulse = keyframes`
    0% { transform: scale(1.3); }
    50% { transform: scale(1); }
    100% { transform: scale(1.3); }
`;

/* Shimmer effect for thumbnail loaders (used in course modal) */
const shimmerThumb = keyframes`
    0% { background-position: 100% 0; opacity: 0.35; }
    100% { background-position: -100% 0; opacity: 0.35; }
`;

export const DataContainerStyled = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.6rem;
    width: 95%;
    margin: 0.5rem auto;
    box-shadow: 0px 8px 16px -4px rgba(0, 0, 0, 0.3);
    min-height: 80vh;
    border-radius: 1.25rem;
    overflow: hidden;
    background: ${({ theme }) => theme === 'dark' ? '#0C1E28' : '#fff'};
    .controls{  
        display: flex;
        width: 95%;
        margin: 0 auto;
        justify-content: space-between;
        align-items: center;
        .icon {
            background: rgba(111, 203, 209, 0.15);
            width: fit-content;
            padding: 0.3rem 0.7rem;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 1.25rem;
            color: ${({theme}) => theme === 'dark' ? '#fff' : '#fff'};
            cursor: pointer;
        }
}
            /* Explicit wrapper for Next buttons to force right alignment */
            .nextBtnWrap{
                margin-left: auto;
                display: flex;
                justify-content: flex-end;
            }
            /* Ensure the button inside the wrapper fills the wrapper width */
            .nextBtnWrap > *{
                width: 100%;
            }
    //border: 0.01rem solid rgba(0, 0, 0, 0.3);
                /* removed stray margin that broke centering & added top offset */
    
`

export const DataHeaderStyled = styled.header`
    ul{
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: nowrap; /* keep items on one line */
        overflow: hidden; /* ensure parent rounded corners clip children */
        border-top-left-radius: 1.25rem;
        border-top-right-radius: 1.25rem;
        list-style-type: none;
        box-shadow: 0px 8px 16px -4px rgba(0, 0, 0, 0.3);

        li{
            flex: 1 1 0; /* evenly share space and allow shrink */
            min-width: 0; /* allow content to shrink without overflow */
            text-align: center;
            border-right: 0.2px solid rgba(0, 0, 0, 0.3);
            padding: clamp(0.5rem, 2vw, 1rem);
            white-space: nowrap; /* prevent wrapping */
            font-size: clamp(0.75rem, 1.8vw, 1rem); /* responsive text */
            /* Ensure readable text in dark mode */
            color: ${({ theme }) => theme === 'dark' ? '#fff' : 'inherit'};
            &:last-child{
                border-right: none;
            }
        }
        .active{
            background: #5fbec5;
            border: none;
            /* Active should be white in both modes for contrast */
            color: #fff;
            /* carry parent corner radius when first/last is active */
            &.first, &:first-child{
                border-top-left-radius: 1.25rem;
            }
            &.last, &:last-child{
                border-top-right-radius: 1.25rem;
            }

        }
    }
    
`

export const CustomizedContainerStyled = styled.div`
    
`

export const BubblePointsContainerStyled = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 1rem;
    width: 95%;
    padding: 1rem;
    margin: 2rem auto;
    border-radius: 0.7rem;
    background: rgba(111, 203, 209, 0.32);
    .subHeading{
        color: ${({ theme }) => theme === 'dark' ? '#fff' : 'inherit'};
        text-align: center;
        white-space: nowrap; /* keep gained text on one line */
        font-size: clamp(0.85rem, 2.2vw, 1.1rem);
    }
    .bubblePoints{
        width: 100%;
        display: flex;
        justify-content: space-between;
        gap: 1rem;
        .pointsContainer{
            flex: 1;
            border-radius: 1.2rem;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 0 1rem;
            gap: 0.5rem;
            .fillerInfo{
                display: flex;
                justify-content: center;
                align-items: center;
                gap: 0.3rem;
                .fillerText{
                    width: max-content;
                    font-size: clamp(0.85rem, 2.2vw, 1.1rem);
                }
                
            }
            
        }
        ol{
            padding-left: 2rem;
        }
        
        /* Medium and smaller screens: stack and full-width */
        @media (max-width: 1024px){
            flex-direction: column;
            align-items: stretch;
            .pointsContainer{ width: 100%; }
            .fillerInfo{ width: 100%; }
            .fillerText{ text-align: left; white-space: normal; width: 100%; }
        }
    }

    /* Progress bar visibility and full width on medium/smaller screens */
    @media (max-width: 1024px){
        .progress, .progressBar, .progress-container, .bubble-progress{
            display: block;
            width: 100%;
            max-width: 100%;
            align-self: stretch;
            margin: 0.25rem 0 0.5rem 0;
        }
    }
`

export const InfoContainerStyled = styled.div`
    display: flex;
    align-items: center;
    gap: clamp(1rem, 4vw, 3rem);
    width: 95%;
    padding: 1rem;
    margin: 2rem auto;
    color: ${({ theme }) => theme === 'dark' ? '#fff' : '#000'};
    text-align: left; /* ensure text is left-aligned by default */
    .insightsGrid{
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 1rem;
        width: 100%;
    }
    /* Ensure progress bar, if present inside this container, gets its own line */
    .progress, .progressBar, .progress-container{
        width: 100%;
        margin-top: 0.5rem;
    }
    border-radius: 0.7rem;
    background: rgba(255, 205, 41, 0.15);
    .alertIcon{
        color: rgba(255, 205, 41, 1);
        font-size: clamp(2rem, 6vw, 5rem);
        animation: ${pulse} 1.5s infinite ease-in-out;
        transform-origin: center    ;
    }
    ul{
        .emphasis{
            color: #5fbec5;
        }
    }
    @media (max-width: 768px){
        flex-direction: column;
        text-align: left; /* keep left alignment on small screens */
        .insightsGrid{
            grid-template-columns: 1fr;
        }
    }
`

/* Preview Resume - Course modal styled pieces */
export const PreviewCourseModalStyled = styled.div`
    padding: 20px;
    max-width: 760px;
    width: 100%;
    box-sizing: border-box;
    h3{ margin: 0; font-size: clamp(1rem, 2.5vw, 1.25rem); }
    p{ margin-top: 6px; margin-bottom: 12px; color: #666; font-size: clamp(0.85rem, 2vw, 1rem); }
    /* Extra breathing room from modal edges on very small devices */
    @media (max-width: 400px){
        margin: 50px; /* space between this container and its modal parent */
    }
    .videoChoices{
        display: flex;
        gap: 8px;
        margin-top: 12px;
        align-items: center;
        flex-wrap: wrap; /* allow wrapping on small screens */
    }
    .videoChoices .thumb{
        width: clamp(96px, 30vw, 140px);
        aspect-ratio: 16 / 9;
        object-fit: cover;
        border-radius: 6px;
        cursor: pointer;
        border: 2px solid transparent;
        transition: transform 0.12s ease, border-color 0.12s ease;
    }
    .videoChoices .thumb:hover{ transform: translateY(-3px); }
    .videoChoices .thumb.selected{ border-color: #5fbec5; }
    /* Thumbnail loader blocks: shimmer rectangle matching thumb aspect */
    .videoChoices .thumbLoader{
        width: clamp(96px, 30vw, 140px);
        aspect-ratio: 16 / 9;
        border-radius: 6px;
        position: relative;
        overflow: hidden;
        background: linear-gradient(90deg,
            rgba(230,230,230,0.25) 0%,
            rgba(255,255,255,0.85) 50%,
            rgba(230,230,230,0.25) 100%
        );
        background-size: 200% 100%;
        animation: ${shimmerThumb} 1.5s ease-in-out infinite;
    }
`;

export const CourseVideoRow = styled.div`
    display: flex;
    gap: 12px;
    align-items: center;
    width: 100%;
    .videoWrapper{
        flex: 1 1 auto;
        position: relative;
        height: 0;
        padding-bottom: 56%; /* 16:9 */
        border-radius: 8px;
        overflow: hidden;
        background: #f6f6f6;
    }
    .actions{
        flex: 0 0 auto;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-left: 8px;
    }
    @media (max-width: 768px){
        gap: 8px;
    }
`;

export const SaveIconStyled = styled.div`
    cursor: pointer;
    font-size: clamp(1.2rem, 4vw, 1.5rem);
    padding: 8px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.15s ease, transform 0.12s ease, color 0.12s ease;
    background: transparent;
    color: #5fbec5;
    border: none;
    &:hover{ background: rgba(95,190,197,0.10); transform: translateY(-1px); }
    /* When saved, subtly highlight */
    &.saved{ color: #5fbec5; background: rgba(95,190,197,0.12); }
`;

export const DataOutletContainerStyled = styled.div`
    display: flex;
    flex-direction: column;
    border: 1px solid #5fbec5;
    gap: 1rem;
    border-radius: 0.7rem;
    width: 95%;
    margin: 0 auto;
    background: ${({ theme }) => theme === 'dark' ? '#0C1E28' : '#fff'};
    overflow: hidden;
    .dataContent{
        padding-bottom: 2rem;
        display: flex;
        flex-direction: column;
        gap: 1rem;
        justify-content: center;
        align-items: center;
        .infoText{
            text-align: center;
            color:  ${({ theme }) => theme === 'dark' ? 'rgba(111, 203, 209, 1) ': 'rgba(0, 153, 144, 1)'};
        }
        
    }
   

`

export const OutletHeaderStyled = styled.header.withConfig({
    shouldForwardProp: (prop) => !['active'].includes(prop)
})`
    .headerOutlet{
        display: flex;
        justify-content: space-between;
        align-items: stretch;
        flex-wrap: nowrap; /* keep tabs on one line */
        height: clamp(44px, 6.5vw, 64px); /* prevent vertical reflow during animation */
        overflow: hidden; /* clip internal growth */
        list-style-type: none;
        

        li{
            display: flex;
            gap: 0.3rem;
            justify-content: center;
            align-items: center;
            height: 100%;
            padding: 0 clamp(0.6rem, 2vw, 1rem); /* fix vertical height, keep horizontal padding responsive */
            background: #5fbec5;
            font-size: clamp(0.75rem, 1.8vw, .95rem);
            cursor: pointer;
            /* Ensure readable text in dark mode */
            color: ${({ theme }) => theme === 'dark' ? '#fff' : 'inherit'};
            transition:
                    flex 0.9s ease,
                    background 0.9s ease,
                    border-radius 0.9s ease; /* smooth animation */
            .icon{
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                font-size: clamp(0.9rem, 2.5vw, 1.4rem); /* baseline icon size */
                transition: transform 0.3s ease;
            }
        }
    
        .fromOld{
            flex: ${({active})=> active === 1 ? 1 : 0.5};
            border-bottom-right-radius: ${({active})=> active === 2 ? '1.25rem' : '0'};
            background: ${({active})=> active === 1 ? 'none' : '#5fbec5'};
            .icon{
                transform: ${({active}) => active === 1 ? 'scale(1.25)' : 'scale(1)'}; /* animate without layout shift */
                color: ${({active}) => active === 1 && 'rgba(255, 205, 41, 1)'};
            }
        }

        .fromNew{
            flex: ${({active})=> active === 2 ? 1 : 0.5};
            border-bottom-left-radius: ${({active})=> active === 1 ? '1.25rem' : '0'};
            background: ${({active})=> active === 2 ? 'none' : '#5fbec5'};
            .icon{
                transform: ${({active}) => active === 2 ? 'scale(1.25)' : 'scale(1)'}; /* animate without layout shift */
                color: ${({active}) => active === 2 && 'rgba(255, 205, 41, 1)'};

            }
        }
    }
`
export const PageDataContainerStyled = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    width: 100%;
    h2{
        text-align: center;
        color: ${({theme}) => theme === 'dark' ? 'rgba(255, 205, 41, 1)' : 'inherit'};
        margin-bottom: 0.75rem;
    }
    h4{
        color: ${({theme}) => theme === 'dark' ? '#fff' : '#000'};
    }
    /* Optimize button row responsive width */
    .optimizeBtnRow{
        width: 60%;
        align-self: center;
        margin: 30px auto 4rem auto;
    }
    @media (min-width: 1024px){
        .optimizeBtnRow{ width: 40%; }
    }
    .contentSection {
        display: flex;
        width: 95%;
        margin: 0 auto;
        gap: clamp(1rem, 3vw, 2rem);
        align-items: stretch; /* ensures equal height */

        .dragDropSection,
        .inputSection {
            flex: 1;
            min-height: 100%; /* ✅ match tallest sibling */
        }

        .dragDropSection {
            display: flex;
            flex-direction: column;
            width: 100%;
            justify-content: space-between;
            gap: 1rem;
            min-height: 100%;

            /* Ensure local styles for Additional Info wrapper and upload bar apply in this scope */
            .textareaWrapper{
                position: relative;
                width: 100%;
            }
            .uploadBtnBar{
                width: 100%;
                background: rgba(111, 203, 209, 0.15); /* match Additional Info inner field */
                padding: 0.75rem; /* requested padding */
                border-bottom-left-radius: 1.25rem;
                border-bottom-right-radius: 1.25rem;
                display: flex;
                align-items: center;
                gap: 0.6rem;
                margin-top: -0.3rem; /* visually join with textarea above */
            }

            .optional {
                

                p {
                    font-size: .8rem;
                    color: ${({ theme }) =>
                            theme === "dark"
                                    ? "rgba(255, 255, 255, 0.44)"
                                    : "rgba(12, 30, 40, 0.71)"};
                }
            }
        }

        .inputSection {
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            gap: 1rem;
            min-height: 100%;
        }
        /* Stack sections on smaller screens */
        @media (max-width: 900px){
            flex-direction: column;
            .dragDropSection, .inputSection{
                width: 100%;
                padding: 0 0.75rem; /* small horizontal padding on narrow screens */
            }
        }
    }
`

export const DragAndDropContainerStyled = styled.div.withConfig({
    shouldForwardProp: (prop) => !['fileError'].includes(prop)
})`
    background: rgba(111, 203, 209, 0.15);
    border: ${({fileError})=> fileError ? '1px dashed crimson' : '1px dashed #fff'};
    width: 100%;
    border-radius: 1.25rem;
    display: flex;
    height: 180px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 2rem;
    gap: 0.2rem;
    .dropFileInfo{
        text-align: center;
        font-size: 1.2rem;
        span{
            color: rgba(242, 72, 34, 1);
            font-size: .8rem;
        }
    }
    /* When a file is selected, match the green used by the infoText above */
    .dropFileInfo.selected span{
        color: ${({ theme }) => theme === 'dark' ? 'rgba(111, 203, 209, 1)' : 'rgba(0, 153, 144, 1)'};
    }
    /* File name should match input placeholder color */
    .dropFileInfo.dropFileName{
        color: ${({theme})=> theme === 'dark' ? '#fff' : '#000'};
    }
`

export const OptimizeInputsContainerStyled = styled.div`
    .textarea{
        width: 100%;
        background: rgba(111, 203, 209, 0.15);
        /* Increased vertical padding by 0.5rem top and bottom (total +1rem height) */
        padding: 1.2rem;
        border-top-left-radius: 1.25rem; 
        border-top-right-radius: 1.25rem; 
        outline: none;
        border: none;
        overflow-y: auto; /* allow showing scrollbar when exceeding max */
        font-size: 1rem; /* baseline to match single-line inputs */
        color: ${({theme})=> theme === "dark" ? 'rgba(255, 255, 255, 0.44)' : 'rgba(12, 30, 40, 0.5)'};
        &::placeholder {
            color: ${({theme})=> theme === "dark" ? 'rgba(255, 255, 255, 0.44)' : 'rgba(12, 30, 40, 0.5)'};

        }
        /* Thin scrollbar styling */
        &::-webkit-scrollbar{
            width: 4px;
        }
        &::-webkit-scrollbar-track{
            background: transparent;
        }
        &::-webkit-scrollbar-thumb{
            background: rgba(95, 190, 197, 0.6);
            border-radius: 8px;
        }
    }
   
    .inputText{
        width: 100%;
        border: none;
        outline: none;
        background: rgba(111, 203, 209, 0.15);
        padding: 1.25rem;
        border-radius: 1.25rem;
        color: ${({theme})=> theme === "dark" ? '#fff' : '#0C1E28'};
        font-size: 1rem;
        &:not(:placeholder-shown) {
            border: none;
        }
        &::placeholder{
            /* Match additional info textarea placeholder color */
            color: ${({theme})=> theme === "dark" ? 'rgba(255, 255, 255, 0.44)' : 'rgba(12, 30, 40, 0.5)'};
        }

        /* Date picker icon color to match placeholder in dark mode */
        &[type="date"]::-webkit-calendar-picker-indicator{
            ${({theme}) => theme === 'dark' ? `
                filter: invert(1);
                opacity: 0.44;
            ` : ''}
        }
    }
    .inputMobile{
        background: rgba(111, 203, 209, 0.15);
        border: none;
        padding: 1.25rem 1.25rem 1.25rem 3.5rem; /* match single-line inputs height */
        border-radius: 1.25rem;
        height: inherit;
        width: 100%;
        color: ${({theme})=> theme === "dark" ? '#fff' : '#0C1E28'};
        font-size: 1rem;
        &::placeholder{
            /* Match additional info textarea placeholder color */
            color: ${({theme})=> theme === "dark" ? 'rgba(255, 255, 255, 0.44)' : 'rgba(12, 30, 40, 0.5)'};
        }
    }
    .countryBox{
        background: none;
        border: none;
        padding: 0 0 0 0.5rem;
        border-right: 1px solid rgba(57, 104, 107, 0.5);
        border-top-left-radius: 1.25rem;
        border-bottom-left-radius: 1.25rem;
        opacity: 1;
        
        .selected-flag{
            background: none;
            &:hover{
                background: rgba(111, 203, 209, 0.15);
            }
            &:active{
                background: rgba(111, 203, 209, 0.15);
            }
            
        }
        &:hover{
            background: none;
        }


    }
    .selectWrapper {
        position: relative;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        select{
            appearance: none;
            width: 100%;
            /* Force readable background for all dropdowns in dark mode */
            background: ${({theme})=> theme === 'dark' ? '#122732' : 'rgba(111, 203, 209, 0.15)'};
            color: ${({theme})=> theme === 'dark' ? '#fff' : '#0C1E28'};
            border-radius: 1.25rem;
            padding: 1.25rem; /* exactly match single-line input padding */
            font-size: 1rem;
        }
        .icon {
            position: absolute;
            right: 1rem;
            pointer-events: none;
            font-size: 1.2rem;
            color: rgba(111, 203, 209, 1);
        }
        
    }
    /* Dark-mode readable dropdowns (general selects) */
    select.inputText{
        background: ${({theme})=> theme === 'dark' ? '#122732' : 'rgba(111, 203, 209, 0.15)'};
        color: ${({theme})=> theme === 'dark' ? '#fff' : '#0C1E28'};
        font-size: 1rem;
    }
    /* Ensure language selects get dark background even if classes differ */
    select.inputSelect{
        background: ${({theme})=> theme === 'dark' ? '#122732' : 'rgba(111, 203, 209, 0.15)'} !important;
        color: ${({theme})=> theme === 'dark' ? '#fff' : '#0C1E28'} !important;
        border-radius: 1.25rem;
        padding: 1.25rem; /* match single-line input */
        font-size: 1rem;
    }
    .addLinks{
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 1rem;
        input{
                &::placeholder{
                    /* Match additional info textarea placeholder color in both themes */
                    color: ${({theme})=> theme === "dark" ? 'rgba(255, 255, 255, 0.44)' : 'rgba(12, 30, 40, 0.5)'};
                }
        }
        .actions{
            display: flex;
            justify-content: center;
            align-items: center;
            width: 30px;
            height: 30px;
            border-radius: 50%;
            aspect-ratio: 1 / 1;
            cursor: pointer;
            font-size: 1.2rem;
        }
        .del{
            border: 1px solid crimson;
            color: crimson;
        }
        .add{
            background: #5fbec5;
            color: ${({theme})=> theme === "dark" ? "#0C1E28" : "#fff"};
        }
        
    }
    .experience{
        p{
            font-size: .6rem;
            margin-bottom: .2rem;
            color: ${({theme})=> theme === "dark" ? '#fff' : '#000'};
        }
    }

    /* Avoid iOS zoom: enforce 16px on small screens */
    @media (max-width: 768px){
        .inputText,
        .inputMobile,
        .textarea,
        select.inputText,
        select.inputSelect{
            font-size: 16px; /* prevent iOS zoom */
        }
    }
    .checkboxWrapper{
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 0.6rem;
        & input[type="checkbox"]{
            accent-color: #5fbec5;
            color: #fff;
        }
        & input.checkbox-ios-pwa[type="checkbox"] {
            appearance: none;
            -webkit-appearance: none;
            width: 16px;
            height: 16px;
            border: 2px solid #5fbec5;
            border-radius: 3px;
            background-color: transparent;
            position: relative;

            &:checked {
                background-color: #5fbec5;
            }

            &:checked::after {
                content: '';
                position: absolute;
                left: 4px;
                top: 0px;
                width: 4px;
                height: 8px;
                border: solid white;
                border-width: 0 2px 2px 0;
                transform: rotate(45deg);
            }
        }
        label{
            color: ${({theme})=> theme === "dark" ? '#fff' : '#0C1E28'};
        }
    }
    .languageWrapper{
        position: relative;
        display: grid; /* grid to allow input group + delete alignment */
        grid-template-columns: 1fr auto;
        width: 100%;
        align-items: center;
        gap: 1rem;
        .selectWrapper {
            background: ${({theme})=> theme === 'dark' ? '#122732 !important' : 'rgba(111, 203, 209, 0.15)'};
            border: none;
            padding: 0; /* avoid double padding; inner select handles height */
            border-radius: 1.25rem;
            select{
                appearance: none;
                background: transparent; /* let wrapper color show */
                border: none;
                color: ${({theme})=> theme === "dark" ? "#fff" : "#0C1E28"};
                outline: none;
        
            }
            .icon {
                right: 1rem;
                pointer-events: none;
                font-size: 1.2rem;
                color: rgba(111, 203, 209, 1);
            }
            
            
        }
        .language{
            flex: 2;
            border-right: 1px solid #5fbec5;
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
            max-width: none; /* allow full width within container */
        }
        .level{
            flex: 1;
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
            max-width: none; /* allow full width within container */

        }
    }

`

export const StepsContainerStyled = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2rem;
    h2{
        color: ${({theme}) => theme === 'dark' ? 'rgba(255, 205, 41, 1)' : 'inherit'};
        span{
            color: #5fbec5;
        }
    }
    h4{
        color: ${({theme}) => theme === 'dark' ? '#fff' : '#000'};
    }
    .basic{
        width: 95%;
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 1rem;
        margin: 0 auto;
    }
    /* Stack all inputs on small screens */
    @media (max-width: 768px){
        .basic{
            grid-template-columns: 1fr;
            width: 100%;
            padding: 0 0.75rem; /* add a little horizontal breathing room */
        }
    }
    .btn{
        width: 30%;
        align-self: flex-end;
        /* Match right spacing to the inner content margins on larger screens */
        margin-right: 2.5%;
        margin-bottom: 4rem;
    }
    /* Mobile tweaks for the Education button */
    @media (max-width: 768px){
        .btn{
            /* Ensure the button is not too small on narrow screens */
            width: 40%;
            min-width: 40%;
            /* Match the small-screen horizontal padding used by inputs */
            margin-right: 0.75rem;
        }
    }
    .btnS{
        width: 95%;
        margin: 0 auto;
        display: flex;
        justify-content: space-around;
        /* Add comfortable space from the bottom of the container */
        margin-bottom: 4rem;
        gap: 0.75rem; /* breathing room between buttons */
    }
    /* Desktop/tablet: match Basic Info button width (30%) for each */
    @media (min-width: 769px){
        .btnS > *{
            width: 30%;
        }
    }
    .educationInfo{
        width: 95%;
        margin: 0 auto;
        .eduContainer{
            display: flex;
            flex-direction: column;
            gap: 1rem;
        }
    }
    /* Education: small-screen side padding and button sizing */
    @media (max-width: 768px){
        .educationInfo{
            width: 100%;
            padding: 0 0.75rem; /* match inputs' side padding */
        }
        .btnS{
            padding: 0 0.75rem; /* align with input side padding */
            flex-wrap: wrap;
            gap: 0.75rem; /* spacing when they wrap */
        }
        /* Ensure each button has at least 40% width on small screens */
        .btnS > *{
            min-width: 40%;
            flex: 1 1 45%;
        }
    }
`

export const EduCardStyled = styled.div`
    width: 95%;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    box-shadow: ${({theme})=> theme === "dark" ? "0px 4px 4px 0px rgba(95, 190, 197, 0.2)" : "0px 4px 4px 0px rgba(12, 30, 40, 0.15)"};
    border-radius: 1.25rem;
    gap: 1rem;
    padding: 1rem;
    .inputs{
        display: flex;
        justify-content: space-around;
        gap: 1rem;
        > div {
            flex: 1;        
            min-width: 200px;
        }
    }
    /* Stack inputs and add breathing room on narrow screens */
    @media (max-width: 768px){
        padding: 1rem 0.75rem; /* match small-screen padding pattern */
        .inputs{
            flex-direction: column;
        }
        .inputs > div{
            min-width: 100%;
        }
    }
    
    


`

export const ExpCardStyled = styled.div`
    width: 95%;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    box-shadow: ${({theme})=> theme === "dark" ? "0px 4px 4px 0px rgba(95, 190, 197, 0.2)" : "0px 4px 4px 0px rgba(12, 30, 40, 0.15)"};
    border-radius: 1.25rem;
    gap: 1rem;
    padding: 1rem;
    h4{
        color: ${({theme}) => theme === 'dark' ? '#fff' : '#000'};
    }
    .input{
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        justify-content: center;
        gap: 1rem;
        .half{
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 1rem;
        }
    }
    
    .currently{
        display: flex;
        justify-content: flex-end;
    }

    /* Mobile-friendly layout: stack fields and add side padding */
    @media (max-width: 768px){
        padding: 1rem 0.75rem; /* match small-screen padding pattern */
        .input{
            grid-template-columns: 1fr;
        }
        .input .half{
            grid-template-columns: 1fr;
        }
    }


`;

export const ButtonActionStyled= styled.div.withConfig({
    shouldForwardProp: (prop) => !['skill'].includes(prop)
})`
    display: flex;
    gap: 1rem;
    align-self: ${({skill})=> skill ? 'center' : 'flex-end'};
    .del{
        display: flex;
        justify-content: center;
        align-items: center;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        aspect-ratio: 1 / 1;
        cursor: pointer;
        font-size: 1.2rem;
        border: 1px solid crimson;
        color: crimson;
    }
    .add{
        display: flex;
        justify-content: center;
        align-items: center;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        aspect-ratio: 1 / 1;
        cursor: pointer;
        font-size: 1.2rem;
        background: #5fbec5;
        color: ${({theme})=> theme === "dark" ? "#0C1E28" : "#fff"};
    }
    
`

export const SkillsCardStyled = styled.div`
    width: 95%;
    display: flex;
    justify-content: start;
    align-items: center;
    margin: 0 auto;
    box-shadow: ${({theme})=> theme === "dark" ? "0px 4px 4px 0px rgba(95, 190, 197, 0.2)" : "0px 4px 4px 0px rgba(12, 30, 40, 0.15)"};
    border-radius: 1.25rem;
    gap: 1rem;
    padding: 1rem;
    .input{
        width: 100%;
        display: grid;
        gap: 1rem;
        grid-template-columns: repeat(3, minmax(0, 1fr)); /* Desktop: max 3 per row */

        /* Medium screens: 2 per row */
        @media (max-width: 1024px){
            grid-template-columns: repeat(2, minmax(0, 1fr));
        }

        /* Small screens: 1 per row */
        @media (max-width: 640px){
            grid-template-columns: 1fr;
        }

        /* Ensure each row (input + delete icon) spans full available width */
        > div{
            display: grid !important; /* override inline flex style */
            grid-template-columns: 1fr auto; /* input grows, icon auto-width */
            align-items: center;
            gap: 1rem;
            width: 100%;
        }
    }
    

`;

export const CertificationCardStyled = styled.div`
    width: 95%;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    box-shadow: ${({theme})=> theme === "dark" ? "0px 4px 4px 0px rgba(95, 190, 197, 0.2)" : "0px 4px 4px 0px rgba(12, 30, 40, 0.15)"};
    border-radius: 1.25rem;
    gap: 1rem;
    padding: 1rem;
    .input{
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 1rem;
        > div { flex: 1; min-width: 200px; }
    }
    @media (max-width: 768px){
        padding: 1rem 0.75rem;
        .input{
            grid-template-columns: 1fr;
        }
        .input > div{ min-width: 100%; }
    }
`;

export const LanguageCardStyled = styled.div` 
    width: 95%;
    display: flex;
    flex-direction: row;
    margin: 0 auto;
    box-shadow: ${({theme})=> theme === "dark" ? "0px 4px 4px 0px rgba(95, 190, 197, 0.2)" : "0px 4px 4px 0px rgba(12, 30, 40, 0.15)"};
    border-radius: 1.25rem;
    gap: 1rem;
    padding: 1rem;
    .items{
        width: 100%;
        display: grid;
        gap: 1rem;
        grid-template-columns: repeat(3, minmax(0, 1fr)); /* Desktop: up to 3 per row */

        /* Medium screens: 2 per row */
        @media (max-width: 1024px){
            grid-template-columns: repeat(2, minmax(0, 1fr));
        }

        /* Small screens: 1 per row */
        @media (max-width: 640px){
            grid-template-columns: 1fr;
        }

        /* Ensure each language item (wrapper + delete) spans full row width */
        > *{
            width: 100%;
        }
        /* Layout the language wrapper content as input group + delete */
        .languageWrapper{
            display: grid;
            grid-template-columns: 1fr auto; /* selects grow, delete auto */
            align-items: center;
            gap: 1rem;
            width: 100%;
        }
    }

`;

/* Fixed-width box for the duration slider with mobile override */
export const SliderBox = styled.div`
    width: 150px;
    margin: 0;
    padding: 0;
    padding-top: 0.4rem; /* align slider vertically with label text */
        transform: translateY(4px); /* nudge down in case margin is collapsed by flex alignment */
    @media (max-width: 768px){
        width: 120px; /* mobile screens */
    }
`;